<template>
  <div class="toTop-container" @click="toTop" v-if="scroll_Top > 1500">
    <img src="../../assets/toTop.png" alt="" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      scroll_Top: "",
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      //   console.log(document.documentElement.scrollTop);
      this.scroll_Top = document.documentElement.scrollTop;
    },
    toTop() {
      cancelAnimationFrame(timer);
      var timer = requestAnimationFrame(function fn() {
        var oTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (oTop > 0) {
          scrollTo(0, oTop - 200);
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.toTop-container {
  position: fixed;
  bottom: 100px;
  right: 100px;
  z-index: 99;
}
</style>
